export default __webpack_public_path__ + "images/709ad021f517f008d02316a1e3eb2e01-indie.jpg";